import styled from 'styled-components';

export const Container = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  p: {
    maxInlineSize: '250rem',
  },
});
